import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
/* tempexp_20958-next-line */
import { cardUnlinkOutflowTouch } from 'reactApp/appHelpers/featuresHelpers/features/cardUnlinkOutflow';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { CardActions } from 'reactApp/modules/creditCard/creditCard.module';

interface IProps {
    onClose: () => void;
}

const buttons = [EButtonType.accept, EButtonType.cancel];

export const RemoveCardModal = memo<IProps>(({ onClose }) => {
    const dispatch = useDispatch();

    const renderHeader = useCallback(() => 'Удаление карты', []);
    const renderContent = useCallback(() => 'Вы действительно хотите отвязать вашу карту от Облака?', []);

    const handleConfirm = useCallback(() => {
        const queryParams = getQueryParams();
        const source = queryParams?.source;

        dispatch(CardActions.removeCard({ onSuccess: onClose, source }));
        onClose();
    }, [dispatch, onClose]);

    /* tempexp_20958-start */
    if (cardUnlinkOutflowTouch) {
        return null;
    }
    /* tempexp_20958-end */

    return (
        <BaseConfirmDialog
            dataQAId="remove-card-dialog"
            renderHeader={renderHeader}
            successButtonText="Удалить"
            cancelButtonText="Отменить"
            buttons={buttons}
            onClose={onClose}
            onSuccess={handleConfirm}
            renderContent={renderContent}
            closeOnDimmerClick
        />
    );
});

RemoveCardModal.displayName = 'RemoveCardModal';
